import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {PartialWorkout} from '../../../Models/PartialWorkout';
import {PresenterProps, withPresenter} from '../../../Support/with_presenter';
import {CrewsWorkoutsTablePresenter} from './CrewsWorkoutsTablePresenter';
import {classNames} from '../../Support/classNames';
import {WorkoutList} from '../../Components/Workout/WorkoutList';

interface OwnProps {
    partialWorkouts: PartialWorkout[];
    crewList?: boolean;
    page?: number;
    previousPage:() => void;
    nextPage: () => void;
    onPageChange: (page: number) => void;
    userList: Record<number, string>;
}



const CrewsWorkoutsTableComponent: FunctionComponent<OwnProps & PresenterProps<CrewsWorkoutsTablePresenter>> = observer(
    ({presenter, page, previousPage, nextPage, onPageChange, userList}) => {

        return (
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <WorkoutList
                            workoutListViewModels={presenter.workoutListViewModels}
                            userList={userList}
                        />
                    </div>
                    <div className="row">
                        <div className="col-12 d-flex justify-content-center">
                            <ul className="pagination">
                                <li className="page-item">
                                    <button
                                        className={classNames('page-link', {
                                            disabled: page === 1,
                                        })}
                                        onClick={() => previousPage()}
                                        disabled={page === 1}
                                    >
                                        Previous
                                    </button>
                                </li>
                                {[...Array(page)].map((_, i) => 1 + i).slice(-5).map((p) => {
                                    return (
                                        <li
                                            key={p}
                                            className={classNames('page-item', {
                                                active: p === page,
                                            })}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => onPageChange(p)}
                                            >
                                                {p}
                                            </button>
                                        </li>
                                    );
                                })}
                                { (presenter.partialWorkoutCount === 100) && page && (
                                    <li
                                        key={page + 1}
                                        className={classNames('page-item')}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => nextPage()}
                                            >
                                                {page + 1}
                                            </button>
                                        </li>
                                )

                                }
                                <li className="page-item">
                                    <button
                                        className={classNames('page-link', {
                                            disabled: presenter.partialWorkoutCount < 100,
                                        })}
                                        onClick={() => nextPage()}
                                        disabled={presenter.partialWorkoutCount < 100}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    },
);

export const CrewsWorkoutsTable = withPresenter<CrewsWorkoutsTablePresenter, OwnProps>(
    (props, component) =>
        new CrewsWorkoutsTablePresenter(props.partialWorkouts, component.network.workouts),
    CrewsWorkoutsTableComponent,
);
